import { LinearProgressProps } from "@mui/material";
import { ProgressBarWithLabelContainer } from "./ProgressBarWithLabel.styles.ts";
import LinearProgress from "@mui/material/LinearProgress";

const ProgressBarWithLabel = (props: LinearProgressProps & { value: number }) => {
	const isOverFilled = props.value > 100;
	return (
		<ProgressBarWithLabelContainer isOverFilled={isOverFilled}>
			<div>{`${Math.floor(props.value)}%`} Full</div>
			<LinearProgress
				variant="determinate"
				{...props}
			/>
		</ProgressBarWithLabelContainer>
	);
};

export default ProgressBarWithLabel;
